import React from "react";
import { useIntl } from 'react-intl';
import { endpoints } from 'Core/defaultValues';
import { useSupportChatAvailable } from 'Modules/.common/hooks/useSupportChatAvailable';

//Components
import { Button, IconButton, Tooltip } from '@gpstrackit/gtc-react-controls'

const Summary = ({ openChat }) => {
    const { messages } = useIntl();

    const supportChatAvailable = useSupportChatAvailable();

    const openTrobleshooting = () => {
        window.open(endpoints.TROUBLESHOOTING_URL, "_blank")
    }

    return (
        <div>
            <p>{messages['troubleshootDevice_theTrobleshootingCompleted']}</p>
            <p>{messages['troubleshootDevice_additionalSupport']}<IconButton
                className="troubleshoot-device-icon"
                onClick={() => openTrobleshooting()}
                size="small"
                icon="open_in_new"
                style={{ color: '#00c8f8' }}
            /></p>
            <p>{messages['troubleshootDevice_endMessage']}</p>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 50 }}>
                <Tooltip
                    title={supportChatAvailable
                        ? messages["header_chatEnabled"]
                        : messages["header_chatDisabeld"]}
                >
                    <Button
                        variant='primary'
                        onClick={(e) => {
                            if (e) e.preventDefault();
                            openChat && openChat()
                        }}
                    >
                        {messages['troubleshootDevice_supportChat']}
                    </Button>
                </Tooltip>

            </div>
        </div>
    )
}

export default Summary